<template>
  <div>
    <div id="accordionMeasurement">
      <div class="card-pei">
        <div
          class="cursor--pointer"
          aria-expanded="true"
          aria-controls="collapseOne"
          @click="toggleExpand"
        >
          <div class="accordion-header-container">
            <div class="collapse-title d-flex">
              <span class="bg-light-gray my-3 radius-20">
                <span class="bg-white p-1 radius-100">
                  <i
                    class="fal fa-lg"
                    :class="{
                      'fa-chevron-circle-right orange': !isExpanded,
                      'fa-chevron-circle-down text-success': isExpanded,
                    }"
                  />
                </span>
                Proceso realizado previo a Solicitud de Asistencia Técnica de
                Ubicación
              </span>
            </div>
          </div>
        </div>
        <div
          id="collapseOne"
          :key="'options'"
          :class="{
            'collapse mt-2': !isExpanded,
            'collapse show mt-2': isExpanded,
          }"
          aria-labelledby="headingOne"
        >
          <div class="d-flex flex-column">
            <div class="question-element">
              <div class="item-pane">
                <div class="question-box">
                  <div class="box-number">
                    <div>
                      1
                      <sup class="question-number-sup" />
                    </div>
                  </div>
                </div>
                <div class="question-line col py-3">
                  <p :id="`pName-1`" class="mb-0 p-2 pl-4">
                    ¿Se realizó una prediscusión de caso con un Facilitador
                    Docente?
                  </p>
                </div>
                <div
                  class="align-items-start d-flex p-0 custom-radio-container"
                >
                  <ValidationProvider>
                    <RadioButton
                      :name="'rbQuestion-1'"
                      :question-lists="getOptions"
                      :change-event="onChange"
                      :disabled="isReadOnly"
                      class="radio-button-container"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showMsgErrorSection1" class="div-error">
            <p class="px-2 mb-0">
              Favor de proceder a realizar el proceso de prediscusión de caso
              con el facilitador correspondiente. Una vez lo realice, podrá
              ingresar la evidencia y comenzar con el proceso de Solicitud de
              Asistencia Técnica de Ubicación del Estudiante.
            </p>
          </div>
          <div
            v-if="
              municipalitiesList.length > 0 &&
                model.facilitatorDiscussionOccurred
            "
            :key="'preDiscussion'"
            class="p-3 bg"
          >
            <div class="row">
              <div class="col-md-4 col-sm-12 mb-3">
                <label class="input-label">Tipo de Solicitud:</label>

                <b-form-group v-slot="{ ariaDescribedby }">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <b-form-radio-group
                      v-model="selected"
                      :options="options"
                      :aria-describedby="ariaDescribedby"
                      name="radio-inline"
                      class="d-flex align-items-center radio-container"
                      :disabled="isProcessPrediscussionReadOnly || isReadOnly"
                      @change="onRequestTypeSelected"
                    />
                    <Error
                      v-if="errors[0]"
                      variant="no-border"
                      message="Favor seleccionar tipo de solicitud."
                    />
                    <Error
                      v-if="typeNewValidation != null && typeNewValidation"
                      variant="no-border"
                      message="No es posible seleccionar tipo Nuevo, ya que el estudiante cuenta con una institución y/o el rol es Director o Maestro público."
                    />
                    <Error
                      v-if="
                        typeRenovationValidation != null &&
                          typeRenovationValidation
                      "
                      variant="no-border"
                      message="No es posible seleccionar tipo Renovación, ya que el estudiante cuenta con una escuela pública y/o el rol es Director o Maestro privado."
                    />

                    <Error
                      v-if="todayIsAfterApril1Error"
                      variant="no-border"
                      message="Las nuevas se podrán realizar a partir del 1 de abril."
                    />
                    <Error
                      v-if="todayIsAfterCanSignPeiDateError"
                      variant="no-border"
                      message="Las renovaciones se podrán realizar a partir del año futuro a partir del 15 de marzo."
                    />
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-md-2 col-sm-12 mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    emptyObject: !(
                      isProcessPrediscussionReadOnly || isReadOnly
                    ),
                    required: !(isProcessPrediscussionReadOnly || isReadOnly),
                  }"
                >
                  <label class="input-label">Año Académico:</label>
                  <div
                    v-if="
                      (isProcessPrediscussionReadOnly || isReadOnly) &&
                        !hasPermisionChangeAcademicYear
                    "
                    class="regular"
                  >
                    {{ model.academicYear && model.academicYear.description }}
                  </div>
                  <CustomDropDown
                    v-else
                    v-model="model.academicYear"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="description"
                    :options="academicYearsList"
                    :error="errors[0]"
                    :clearable="false"
                    @input="onAcademicYearChange($event)"
                  />

                  <Error
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor seleccionar año académico."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-3 col-sm-12 mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    emptyObject: !(
                      isProcessPrediscussionReadOnly || isReadOnly
                    ),
                    required: !(isProcessPrediscussionReadOnly || isReadOnly),
                  }"
                >
                  <label class="input-label">Municipio de Residencia:</label>
                  <div
                    v-if="isProcessPrediscussionReadOnly || isReadOnly"
                    class="regular"
                  >
                    {{ model.municipality && model.municipality.name }}
                  </div>
                  <CustomDropDown
                    v-else
                    v-model="model.municipality"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipalitiesList"
                    :error="errors[0]"
                  />

                  <Error
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor seleccionar municipio de residencia."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-3 col-sm-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    required: !(isProcessPrediscussionReadOnly || isReadOnly),
                  }"
                >
                  <label class="input-label">
                    Nombre del Facilitador Docente:
                  </label>
                  <div
                    v-if="isProcessPrediscussionReadOnly || isReadOnly"
                    class="regular"
                  >
                    {{ model.facilitatorName }}
                  </div>
                  <CustomInput
                    v-else
                    v-model="model.facilitatorName"
                    type="text"
                    :error="errors[0]"
                  />
                  <Error
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor escriba nombre del facilitador docente."
                  />
                </ValidationProvider>
              </div>

              <div class="col-12 mt-1">
                <div class="row">
                  <div class="col-12 col-md-3">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <label class="input-label mb-0">Nombre:</label>
                      <QInput
                        v-model="model.familyMemberName"
                        type="text"
                        :disabled="isReadOnly"
                        :custom-error-msg="
                          'Favor de entrar un nombre de familiar o persona contacto'
                        "
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-md-3">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <label class="input-label mb-0">Parentesco:</label>
                      <p v-if="isReadOnly">{{ relativeName }}</p>
                      <CustomDropDown
                        v-else
                        v-model="model.relative"
                        placeholder="Seleccione"
                        fieldkey="id"
                        fieldname="name"
                        :options="relationships"
                        :error="errors[0]"
                        :clearable="false"
                        :disabled="isReadOnly"
                      />

                      <Error
                        v-if="errors[0]"
                        variant="no-border"
                        message="Favor de seleccionar un parentesco de otro familiar o persona contacto"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-md-3">
                    <ValidationProvider
                      v-slot="{ errors, failedRules }"
                      rules="required|completePhone"
                    >
                      <label class="input-label mb-0">Teléfono:</label>
                      <QInput
                        v-model="model.phone"
                        :mask-type="'Phone'"
                        placeholder="(__) __-____"
                        type="text"
                        :custom-error-msg="
                          failedRules['completePhone']
                            ? 'Se debe completar el número telefónico.'
                            : 'Favor de registrar un teléfono para continuar.'
                        "
                        :error="errors[0]"
                        :disabled="isReadOnly"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-md-3">
                    <ValidationProvider
                      v-slot="{ errors, failedRules }"
                      :custom-messages="{
                        nodomain:
                          'Favor de entrar un correo electrónico que no sea del Departamento de Educación de Puerto Rico.',
                      }"
                      :rules="{
                        required: true,
                        email: true,
                        nodomain: ['de.pr.gov', 'miescuela.pr'],
                      }"
                    >
                      <label class="input-label mb-0">
                        Correo Electrónico:
                      </label>
                      <QInput
                        v-model="model.email"
                        type="email"
                        :custom-error-msg="customErrorMsg(failedRules)"
                        :error="errors[0]"
                        :disabled="isReadOnly"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-3">
                <label class="input-label">Descripción:</label>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="description"
                  :rules="{
                    required: !(isProcessPrediscussionReadOnly || isReadOnly),
                  }"
                >
                  <CustomTextArea
                    v-show="true"
                    :id="'description'"
                    v-model="model.facilitatorDiscussionDescription"
                    style="width:100%"
                    :maxlength="3000"
                    :classes="['eq-field', 'text-left']"
                    :rows="5"
                    :error="errors[0]"
                    :custom-error-msg="'Favor escriba una descripción.'"
                    :disabled="isProcessPrediscussionReadOnly || isReadOnly"
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 col-md-6 col-lg-6 mt-2">
                <label class="input-label">Documento:</label>
                <p class="document-name">
                  Evidencia de prediscusión de caso con Facilitador Docente
                  (SAEE-07)
                </p>
                <div
                  class="d-flex align-items-start align-items-md-center mb-3"
                >
                  <i class="far fa-exclamation-circle pr-1 form-icon" />
                  <p class="m-0">
                    Para someter la solicitud no es requerido anejar el
                    documento de la SAEE-07.
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6 mt-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Archivo"
                  :rules="{
                    required:
                      !(
                        sectionsStates[enums.sections['Proceso Prediscusión']]
                          .readonly || isReadOnly
                      ) && isDocumentRequired,
                  }"
                >
                  <CustomFileInput
                    ref="attachedDocument"
                    v-model="model.facilitatorDiscussionFile"
                    label="Archivo:"
                    :accept="allowedFiles"
                    display-style="normal"
                    label-position="left"
                    :error="errors[0]"
                    :attachment-id="getDocument.documentId"
                    :name="getDocument.filename"
                    :custom-error-msg="
                      errors[0] ? 'Favor anejar un documento.' : ''
                    "
                    :disabled="
                      isProcessPrediscussionReadOnly ||
                        isReadOnly ||
                        !deleteDocuments
                    "
                    :can-replace="canReplaceSaee07Document"
                    @replace="onReplaceSaee07Document"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from '@/components/common/CustomTextArea';
import RadioButton from '@/components/common/CustomRadioButton';
import CustomFileInput from '@/components/common/CustomFileInput';
import { CustomDropDown, Error, CustomInput } from '@/components/common';
import { extend } from 'vee-validate';
import alert from 'utils/mixins/alert.mixin';
import {
  UTA_MANAGEMENT_SECTION_ENUM,
  UTA_MANAGEMENT_REQUEST_TYPE,
} from '@/components/pei/ubication-tech-assistance/_config/management';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';
import store from '@/store/index';
import userRole from '@/utils/constants/userRoles';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import {
  hasTapRequest,
  replaceDocument,
} from '@/services/api/tapRequest.api.js';
import moment from 'moment';
import EduEspCode from '@/utils/constants/eduEspCode';
const GET_EDU_ESP_CODE_PARENT_RELATIONT_TYPE = `api/code/geteduespcodes?codeType=${EduEspCode.ParentRelationType}`;

extend('emptyObject', (value) => {
  return Object.keys(value).length != 0;
});

const requestTypes = Object.freeze({
  Nuevo: 1,
  Renovacion: 2,
  Querella: 3,
});

const SAEE07_DOCUMENT_TYPE_ID = 175;

export default {
  name: 'UbicationTechAssistanceSection1',
  mixins: [alert],
  data() {
    return {
      enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
      allowedFiles: '.pdf',
      selected: null,
      options: [
        { text: 'Nuevo', value: 1 },
        { text: 'Renovación', value: 2 },
        { text: 'Querella', value: 3 },
      ],
      typeNewValidation: null,
      typeRenovationValidation: null,
      todayIsAfterCanSignPeiDateError: false,
      todayIsAfterApril1Error: false,
      relationships: [],
    };
  },
  components: {
    ValidationProvider,
    RadioButton,
    CustomTextArea,
    CustomFileInput,
    CustomDropDown,
    CustomInput,
    Error,
    QInput: () => import('CustomInput'),
  },
  async created() {
    if (this.model) this.selected = this.model.requestType;
    this.getParentRelationType();
  },
  methods: {
    customErrorMsg(failedRules) {
      if (failedRules['nodomain']) {
        return failedRules['nodomain'];
      }

      if (failedRules['email']) {
        return 'El correo electrónico no es válido.';
      }

      return 'El correo electrónico es requerido.';
    },
    async onAcademicYearChange(item) {
      const { data: exist } = await hasTapRequest(
        this.studentSie,
        this.model.academicYear.id
      );
      if (exist) {
        this.ShowToast(
          'Atención',
          `El estudiante ya cuenta con una solicitud en proceso de asistencia técnica para ubicación del estudiante en el año ${this.model.academicYear.description}.`,
          'error'
        );
        return;
      }

      if (item == null) return;
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ['CanSignPeiDate', 'CanRenovateSolicitude'],
        academicYearId: item.id,
      });

      let sysParametersDatesNewSolicitude = (
        sysParameters.find((x) => x.name === 'CanSignPeiDate') || {}
      ).staticValue;

      let sysParametersDatesRenovationSolicitude = (
        sysParameters.find((x) => x.name === 'CanRenovateSolicitude') || {}
      ).staticValue;

      let todayIsAfterCanSignPeiDate = moment().isAfter(
        sysParametersDatesNewSolicitude
      );

      let todayIsAfterApril1 = moment().isAfter(
        sysParametersDatesRenovationSolicitude
      );

      if (this.selected === requestTypes.Nuevo) {
        if (todayIsAfterApril1) {
          this.todayIsAfterApril1Error = false;
          this.todayIsAfterCanSignPeiDateError = false;
          this.$emit('resetTypeValidation', false);
        } else {
          this.todayIsAfterApril1Error = true;
          this.todayIsAfterCanSignPeiDateError = false;
          this.$emit('resetTypeValidation', true);
        }
      } else if (this.selected === requestTypes.Renovacion) {
        if (todayIsAfterCanSignPeiDate) {
          this.todayIsAfterCanSignPeiDateError = false;
          this.todayIsAfterApril1Error = false;
          this.$emit('resetTypeValidation', false);
        } else {
          this.todayIsAfterCanSignPeiDateError = true;
          this.todayIsAfterApril1Error = false;
          this.$emit('resetTypeValidation', true);
        }
      }
    },
    onRequestTypeSelected(item) {
      this.todayIsAfterCanSignPeiDateError = false;
      this.todayIsAfterApril1Error = false;
      this.canSelectNew(item);
      this.model.requestType = item;
    },
    canSelectNew(item) {
      if (item === requestTypes.Querella) {
        this.typeNewValidation = null;
        this.typeRenovationValidation = null;
        this.$emit('resetTypeValidation', false);
      }
      if (
        item === requestTypes.Nuevo &&
        this.isPrivateStudent &&
        this.isDirectorPrivadoOrMaestroPrivado
      ) {
        this.typeNewValidation = true;
        this.typeRenovationValidation = null;
        this.$emit('resetTypeValidation', true);
      } else if (
        item === requestTypes.Renovacion &&
        !this.isPrivateStudent &&
        this.isDirectorOrMaestro
      ) {
        this.typeNewValidation = null;
        this.typeRenovationValidation = true;
        this.$emit('resetTypeValidation', true);
      } else {
        this.typeNewValidation = null;
        this.typeRenovationValidation = null;
        this.$emit('resetTypeValidation', false);
      }
    },
    async onChange(item) {
      this.model.facilitatorDiscussionOccurred = item.id;
      this.$emit('resetMsgErrorSection1');
      if (
        !item.id &&
        this.model.tapRequestStatus === tapRequestStatusesEnum.Nuevo
      ) {
        const response = await this.ShowCancelModal(
          'Confirmación',
          `Usted cuenta con una solicitud creada en sistema, ¿Está que seguro que desea eliminar la solicitud para el estudiante ${store.getters.SelectedStudent.fullName}?`,
          'Sí­',
          'No'
        );
        if (!response) {
          item.check = false;
          this.getOptions.options.filter(
            (op) => op.id === true
          )[0].check = true;
          this.model.facilitatorDiscussionOccurred = true;

          return;
        } else {
          this.$emit('onDeleteTapRequest');
        }
      }
    },
    toggleExpand() {
      this.$emit('expanded', !this.isExpanded);
    },
    async onReplaceSaee07Document(file) {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea reemplazar el documento?',
        'Sí',
        'No'
      );
      if (!confirmed) return;

      await replaceDocument(this.model.id, SAEE07_DOCUMENT_TYPE_ID, file);

      this.ShowToast(
        'Confirmación',
        'El documento ha sido reemplazado exitosamente.',
        'success'
      );
      this.$emit('documentReplaced');
    },
    async getParentRelationType() {
      const { data: relations } = await this.$ApiGet(
        GET_EDU_ESP_CODE_PARENT_RELATIONT_TYPE
      );
      if (relations) {
        this.relationships = [...relations];
      }
    },
  },
  computed: {
    isProcessPrediscussionReadOnly() {
      const sectionState =
        this.sectionsStates[this.enums.sections['Proceso Prediscusión']] ?? {};
      return sectionState?.readonly;
    },
    getDocument() {
      const hasDocuments =
        this.model.documents && this.model.documents.length > 0;
      if (!hasDocuments) {
        return { documentId: null, filename: null };
      }

      const document = this.model.documents.find(
        (x) => x.document.documentTypeId == SAEE07_DOCUMENT_TYPE_ID
      );
      if (!document) {
        return { documentId: null, filename: null };
      }

      return document;
    },
    canReplaceSaee07Document() {
      return this.$store.getters.HasPermission(
        'academic.pei.ubicationtechassistance.request.replaceSaee07'
      );
    },
    isDocumentRequired() {
      return this.selected == UTA_MANAGEMENT_REQUEST_TYPE.NUEVO;
    },
    getOptions() {
      return {
        invalid: false,
        options: [
          {
            id: true,
            label: 'Si',
            check: this.model.facilitatorDiscussionOccurred === true,
            disabled:
              this.sectionsStates[this.enums.sections['Proceso Prediscusión']]
                .readonly || this.isReadOnly,
          },
          {
            id: false,
            label: 'No',
            check: this.model.facilitatorDiscussionOccurred === false,
            disabled:
              this.sectionsStates[this.enums.sections['Proceso Prediscusión']]
                .readonly || this.isReadOnly,
          },
        ],
      };
    },
    isDirectorOrMaestro() {
      const roles = [userRole.director, userRole.maestro];
      const isInRole = roles.some((role) => role === this.userRole);
      return isInRole;
    },
    isDirectorPrivadoOrMaestroPrivado() {
      const roles = [userRole.directorPrivado, userRole.maestroPrivado];
      const isInRole = roles.some((role) => role === this.userRole);
      return isInRole;
    },
    isPrivateStudent() {
      return this.$store.getters.SelectedStudent.studentType === 'Privado'
        ? true
        : false;
    },
    hasPermisionChangeAcademicYear() {
      return (
        this.$store.getters.HasPermission('taprequest.changeacademicyear') &&
        this.selected != requestTypes.Nuevo
      );
    },
    relativeName() {
      return this.model.relativeId
        ? this.relationships.find((x) => x.id === this.model.relativeId)?.name
        : this.model?.relative?.name;
    },
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: true,
    },
    showMsgErrorSection1: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: () => {},
    },
    municipalitiesList: {
      type: Array,
      default: () => [],
    },
    academicYearsList: {
      type: Array,
      default: () => [],
    },
    deleteDocuments: {
      type: Boolean,
      default: true,
    },
    studentSie: {
      type: String,
      default: '',
    },
    sectionsStates: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: () => ({}),
    },
  },
  watch: {
    'model.requestType': {
      handler(value) {
        this.selected = value;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.document-name {
  font: normal normal normal 16px/20px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
}
.radius-20 {
  border-radius: 20px;
}
.radius-100 {
  border-radius: 100%;
}
.bg {
  background: #f7f7f7;
}
.div-error {
  background: #feeaea;
  padding: 20px;
}
.div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
.question {
  /* box-shadow: -3px 1px 3px #00000029; */
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  /* box-shadow: -3px 1px 3px #00000029; */
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.orange {
  color: #ff7058;
}
.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.question-line p >>> p {
  margin-bottom: 0px !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

.row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.text-fix {
  font-weight: 400;
}
.relative-top-10 {
  position: relative;
  top: 0.8em;
}
.card-pei >>> .input-label {
  color: #727272;
  font-size: 14px;
}
.radio-container {
  height: 40px;
}

::v-deep .input-display {
  margin-left: 0 !important;
}
</style>
